import React from "react";

const Section6Payment = () => (
  <>
    <h2>6. Payment Terms, Subscription Fees, Billing Cycles, and Cancellation Policies</h2>
    <p>
    Access to the Service is provided on a subscription basis. The subscription fees applicable to your chosen service plan are detailed on our pricing page or as otherwise agreed upon in writing. Billing cycles are typically monthly or annual, depending on the subscription plan you select. You agree to pay all applicable fees as set forth in your subscription plan. Payments will be processed using the payment method you provide during registration.
    </p>

    <p>
    Your subscription will automatically renew at the end of each billing cycle for the same term unless you cancel it prior to the renewal date. You can manage your subscription and cancel renewal through your Account settings. Cancellation requests must be submitted within the specified timeframe prior to the end of the current billing cycle to avoid charges for the subsequent term.
    </p>
  
    <p>
    Refunds are generally not provided, except in specific cases at the sole discretion of Comparedly Ltd. Any requests for refunds will be considered on a case-by-case basis.
    </p>
  
    <p>
    In the event of late payments, Comparedly Ltd. reserves the right to charge interest on the overdue amount at a rate permitted by applicable law. Comparedly Ltd. may also change the subscription fees upon providing you with reasonable prior notice. Your continued use of the Service after the fee change becomes effective constitutes your agreement to pay the modified subscription fee.
    </p>
  
  </>
);

export default Section6Payment;
